import { SchedulerGridCellSegmentProps } from './types';
import { SchedulerGridSchedule } from '../../schedule';
import { useScheduler } from '@hooks/scheduler';
import { cn } from '@utils/cn';

export const SchedulerGridCellSegment = ({
  date,
  data,
  foreman,
  start,
  end,
  last,
  style,
}: SchedulerGridCellSegmentProps) => {
  const { handlePointerDown, isSegmentDisabled } = useScheduler();

  const disabled = isSegmentDisabled(date) || foreman.droppable;
  const reschedulable = data?.draggable;

  const after = 'after:absolute after:w-[2px] after:h-full after:-left-[1px]';
  const before = cn(
    'before:absolute before:w-full before:h-[2px] before:-bottom-[1px]',
    disabled && !last && 'before:bg-neutral-50',
  );

  return (
    <div
      onPointerDown={(e) => {
        if (foreman.discardedAt) return;
        handlePointerDown(e, foreman);
      }}
      data-start={start ? data?.id : undefined}
      data-date={date.toISOString()}
      data-foreman={JSON.stringify(foreman)}
      data-end={end ? data?.id : undefined}
      className={cn([
        'scheduler-segment relative h-full select-none',
        after,
        before,
        disabled && 'bg-neutral-50',
      ])}
      style={style}>
      {start && data && <SchedulerGridSchedule data={data} reschedulable={reschedulable} />}
    </div>
  );
};
